/*
Author: Chathuraka Mallawa Arachchi
Date: 18/10/2024
Copyright © 2024 Infix!. All rights reserved.

Responsible for form applying validations based on question type
*/


import {constants} from "@/constants"
import {Actions,DateRangeMatrixType,RepeatableMatrix,smokingType} from "@/constants/constants"
import ValidationManager from "../fieldValidations"
import nodeUtilities from "../nodeUtility"
import dateRangeTypes from "../patientQuestions/daterangeType"
import smokingTypes from "../patientQuestions/smokingType"
import {DateRangeType,FormState,IsmokingTypeValue} from "../types/commonTypes"
import {INode} from "../types/nodeTypes"
import {PatientAnswer,ValueTypes} from "../types/patientTypes"

const poaQuestionnaireDetails = (function () {

    const generateQuestionnaireDetailsForm = (answer: PatientAnswer[], questionnaireDetails: INode,  form: FormState) => {

        const questionnair: INode= structuredClone(questionnaireDetails); 

        const generateSections = (pageNode: INode) => {
            if (!nodeUtilities.isNodeTypeExists(pageNode.type)) {
                if (pageNode.type === constants.section || pageNode.type === "Section" || pageNode.type === constants.QuestionSet ||   pageNode.type === constants.FormRow ) { //ToDo : incorrect section name. should be corrected from backend pageNode.type === constants.section
                    pageNode?.nodes?.map((pageNodeItem: INode) => {

                        const generateInnerSection = (sectionNode : INode) => {
                            const  nodeObj = answer.find(item => item.name === sectionNode.name);
                            switch(sectionNode.type) {
                                case smokingType: 
                                    {
                                        const list: string[] = [];
                                        let nodeList: INode[] = [];
     
                                        if (Array.isArray(nodeObj?.value)) {
                                            const isSmokingTypeValue =(node: ValueTypes): node is IsmokingTypeValue => {
                                                return 'type' in node && 'perDay' in node && 'years' in node;
                                            }
                                            nodeObj.value.forEach((node) => {
                                                if ('type' in node) {
                                                    list.push(node.type); // Now TypeScript knows `node` has a `type` property
                                                }
                                                if (isSmokingTypeValue(node)) {
                                                    const nodeListFromValue: INode[] =  smokingTypes.generateSmokingType(node);
                                                    nodeList = [...nodeList, ...nodeListFromValue];  
                                                }
                                                                                    
                                            });
                                            const smokeTypeIndex: number | undefined = pageNode?.nodes && pageNode?.nodes.findIndex( (sectionNode:INode)  =>  sectionNode.name === smokingType);
                                            if(smokeTypeIndex !== -1 && pageNode?.nodes && smokeTypeIndex){
                                                 pageNode.nodes?.splice(smokeTypeIndex +1, 0,  ...nodeList);
                                            }
                                           
                                        }
                                       
                                        sectionNode.value = list;
    
    
                                    }
                                return
                                case DateRangeMatrixType: 
                                case Actions:
                                case RepeatableMatrix:
                                {
                                    const formLocal: FormState = {};
                                    if (Array.isArray(nodeObj?.value)) {
                                        const validatedFormObjects = ValidationManager.applyCommonValidationsWithValue(sectionNode, JSON.stringify(nodeObj?.value));
                                      
                                        formLocal[sectionNode.name] = validatedFormObjects
                                        form = {...form, ...formLocal};
                                       
                                    } else {
                                        const validatedFormObjects = ValidationManager.applyCommonValidationsWithValue(sectionNode, '');
                                        formLocal[sectionNode.name] = validatedFormObjects;
                                        form = {...form, ...formLocal};
                                    }                              
                                }
                                return
                                default: {  
                                    const formLocal: FormState = {};                         
                                 if(nodeObj){
                                   // pageNodeItem.value = nodeObj.value
                                    const validatedFormObjects = ValidationManager.applyCommonValidationsWithValue(sectionNode, nodeObj.value );
                                    formLocal[sectionNode.name] = validatedFormObjects
                                    form = {...form, ...formLocal};
                                 } else {
                                    const validatedFormObjects = ValidationManager.applyCommonValidationsWithValue(sectionNode, '');
                                    formLocal[sectionNode.name] = validatedFormObjects;
                                    form = {...form, ...formLocal};
                                 }
                                
                                }
                            }
                        }

                        if (!nodeUtilities.isNodeTypeExists(pageNodeItem.type)) {
                            generateInnerSection(pageNodeItem)
                                                    
                        }else {
                            pageNodeItem?.nodes?.map((innerNode: INode) => {
                                if (!nodeUtilities.isNodeTypeExists(innerNode.type)) {
                                    generateInnerSection(innerNode)
                                }else {
                                    innerNode?.nodes?.map((innerNodeL1: INode) => {
                                        generateInnerSection(innerNodeL1)
                                    })
                                }
                              
                        
                            })
                        }
                       
                        
                       
                    })
                }
            } else {
                pageNode?.nodes?.map((innerNode: INode) => {
                    generateSections(innerNode)
                })
            }
        }
        questionnair?.nodes?.map((innerNode: INode) => {
            generateSections(innerNode)
        });
        
        // Safeguard: Answer object is created by iterating through the node list. if any answer which is returned from the backend is missing in the node list
        // we still need to add those answers to the form state to make sure they are not lost.
        // This can happen if for some reason the we need to access answers which are not in the node list
        answer.forEach((answerItem: PatientAnswer) => {
            if (!form[answerItem.name]) {
                const formLocal: FormState = {};
                const validatedFormObjects = ValidationManager.applyCommonValidationsWithValue(
                    { name: answerItem.name } as INode, 
                    answerItem.value
                );
                formLocal[answerItem.name] = validatedFormObjects;
                form = {...form, ...formLocal};
            }
        });
        
        return form
    }

    const ApplyValueBasedOnTypes = (answer: PatientAnswer[],pageNodeItem: INode, pageNode: INode, type: string)=> {
        const  nodeObj = answer.find(item => item.name === pageNodeItem.name);
        switch(type) {
            case smokingType: 
                {
                    const list: string[] = [];
                    let nodeList: INode[] = [];

                    if (Array.isArray(nodeObj?.value)) {
                        const isSmokingTypeValue =(node: ValueTypes): node is IsmokingTypeValue => {
                            return 'type' in node && 'perDay' in node && 'years' in node;
                        }
                        nodeObj.value.forEach((node) => {
                            if ('type' in node) {
                                list.push(node.type); // Now TypeScript knows `node` has a `type` property
                            }
                            if (isSmokingTypeValue(node)) {
                                const nodeListFromValue: INode[] =  smokingTypes.generateSmokingType(node);
                                nodeList = [...nodeList, ...nodeListFromValue];  
                            }
                                                                
                        });
                        const smokeTypeIndex: number | undefined = pageNode?.nodes && pageNode?.nodes.findIndex( (pageNodeItem:INode)  =>  pageNodeItem.name === smokingType);
                        if(smokeTypeIndex !== -1 && pageNode?.nodes && smokeTypeIndex){
                             pageNode.nodes?.splice(smokeTypeIndex +1, 0,  ...nodeList);
                            console.log(pageNode);
                        }
                       
                    }
                   
                    pageNodeItem.value = list;


                }
            return
            case DateRangeMatrixType: 
            {
             
                let nodeList: INode[] = [];
                const isDateRange =(node: ValueTypes): node is DateRangeType => {
                    return 'start' in node && 'end' in node ;
                }

                if (Array.isArray(nodeObj?.value)) {
                    const dateRangeValues:  [Date | null, Date | null][]= [] 
                    nodeObj.value.forEach((node, index) => {
                        if(isDateRange(node)) {
                            const nodeListFromValue: INode =  dateRangeTypes.generateDateRangeType(node, index+1);
                            dateRangeValues.push(nodeListFromValue.value)
                            nodeList = [...nodeList, nodeListFromValue];  
                        }
                                                             
                    });
                    pageNodeItem.dateRanges = [...nodeList];
                    pageNodeItem.value = dateRangeValues
                   
                }                               
            }
            return
            default: {                           
             if(nodeObj){
                pageNodeItem.value = nodeObj.value
             }
            
            }
        }
    }

    // const generateQuestionnaireDetailsForANode = (answer: PatientAnswer[], questionnaireDetails: INode, selectedNode: INode) => {

    //     const questionnair: INode= structuredClone(questionnaireDetails); 

    //     const generateSections = (pageNode: INode) => {
    //         if (!nodeUtilities.isNodeTypeExists(pageNode.type)) {
    //             if (pageNode.type === constants.section) {
    //                 pageNode?.nodes?.map((pageNodeItem: INode) => {
    //                     if(pageNodeItem.name === selectedNode.name){
    //                         ApplyValueBasedOnTypes(answer,pageNodeItem,pageNode, selectedNode.type);
    //                         return
    //                     }
                        
    //                 })
    //             }
    //         } else {
    //             pageNode?.nodes?.map((innerNode: INode) => {
    //                 generateSections(innerNode)
    //             })
    //         }
    //     }
    //     questionnair?.nodes?.map((innerNode: INode) => {
    //         generateSections(innerNode)
    //     });
    //     //applyNextPrewNodes(questionnair); // apply next and prev nodes
    //     console.log('updated questionnair', questionnair);
    //     return questionnair

    // }

    const generateQuestionnaireDetails = (answer: PatientAnswer[], questionnaireDetails: INode) => {

        const questionnair: INode= structuredClone(questionnaireDetails); 

        const generateSections = (pageNode: INode) => {
            if (!nodeUtilities.isNodeTypeExists(pageNode.type)) {
                if (pageNode.type === constants.section) {
                    pageNode?.nodes?.map((pageNodeItem: INode) => {
                        ApplyValueBasedOnTypes(answer,pageNodeItem,pageNode, pageNodeItem.type)
                    })
                }
            } else {
                pageNode?.nodes?.map((innerNode: INode) => {
                    generateSections(innerNode)
                })
            }
        }
        questionnair?.nodes?.map((innerNode: INode) => {
            generateSections(innerNode)
        });
        return questionnair
    }



    return {
        //applyNextPrewNodes,
        generateQuestionnaireDetails,
        generateQuestionnaireDetailsForm,
    }
})()

export default poaQuestionnaireDetails
